import setVisibleSuccessMessage from 'root/src/client/logic/app/actions/setVisibleSuccessMessage'

export default (dispatch, position) => {
	dispatch(setVisibleSuccessMessage(true, position, 'Saved'))
	setTimeout(() => {
		dispatch(setVisibleSuccessMessage(false, { x: 0, y: 0 }, ''))
	}, 2000)
}
